export default __webpack_public_path__ + "8d6b6822586eea3d3b2076d171808949.ttf";